import { useState } from 'react'
import type { Member } from '@domain/state.ts'
import { es } from '../strings/es.ts'

/**
 * Quitar a alguien de las listas.
 *
 * Existe porque hasta ahora no había salida: importar una copia en una tablet que
 * ya tenía casa deja miembros duplicados —el registro solo crece, no sustituye— y
 * la única forma de limpiarlo era empezar de cero y perder la historia.
 *
 * Pide confirmación porque es un cambio que se ve en la pantalla de un niño, y
 * dice lo que de verdad hace: no borra. La historia se queda, y si vuelve, vuelve
 * con sus monedas.
 */
export function QuitarMiembro({
  member,
  onArchive,
}: {
  member: Member
  onArchive: (memberId: Member['id'], reason: string) => void
}) {
  const [preguntando, setPreguntando] = useState(false)

  if (!preguntando) {
    return (
      <button
        type="button"
        className="border-rule text-muted mt-6 rounded border px-4 text-sm font-bold"
        onClick={() => {
          setPreguntando(true)
        }}
      >
        {es.config.quitar}
      </button>
    )
  }

  return (
    <div role="alert" className="border-gold bg-gold-soft mt-6 rounded border-t-4 p-4">
      <p className="m-0 font-bold">{es.config.quitarSeguro(member.name)}</p>
      <p className="m-0 mt-1 text-sm">{es.config.quitarHelp}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button
          type="button"
          className="bg-teal rounded px-5 font-bold text-white"
          onClick={() => {
            setPreguntando(false)
            onArchive(member.id, es.config.quitarRazon)
          }}
        >
          {es.config.quitarSi}
        </button>
        <button
          type="button"
          className="border-rule rounded border px-5 font-bold"
          onClick={() => {
            setPreguntando(false)
          }}
        >
          {es.config.quitarNo}
        </button>
      </div>
    </div>
  )
}
